(() => {
  const root = document.querySelector('.labrazaar-article [data-core]');
  if (!root) return;
  const video = root.querySelector('video'), surface = root.querySelector('.core-media');
  const slider = root.querySelector('input'), button = root.querySelector('[data-motion]');
  const controls = root.querySelector('.motion-controls'), status = root.querySelector('[data-core-status]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false, visible = false, duration = 0, target = .5, shown = .5;
  let phase = Math.PI/2, lastInput = performance.now(), lastFrame = 0, raf = 0, failed = false;
  let opticalX = 0, opticalY = 0, opticalShownX = 0, opticalShownY = 0;
  const clamp = v => Math.min(1, Math.max(0, v));
  const smooth = v => v*v*v*(v*(v*6-15)+10);
  const isReduced = () => reduced.matches || new URLSearchParams(location.search).get('motion') === 'reduce';
  let dragging = false, unlocked = false;
  surface.style.touchAction = 'pan-y';
  function unlock() {
    if (unlocked || isReduced() || failed) return;
    visible = true;load();
    video.muted = true;video.playsInline = true;
    const playback = video.play();
    if (playback) playback.then(() => {video.pause();unlocked=true;request();}).catch(() => {request();});
  }
  function point(event) {
    const rect=surface.getBoundingClientRect();
    input(smooth(clamp((event.clientX-rect.left)/rect.width)));
  }
  function input(value) {target = clamp(value);lastInput = performance.now(); request();}
  function load() {
    if (isReduced() || failed || video.src || !visible) return;
    video.src = video.dataset.src;video.preload='auto';video.load();
  }
  function request() {if (!raf && visible && !document.hidden && !isReduced() && !failed) raf=requestAnimationFrame(render);}
  function render(now) {
    raf=0;if(!visible || document.hidden || isReduced() || failed)return;
    const dt=lastFrame?Math.min(48,now-lastFrame):16.67;lastFrame=now;
    if(!paused && now-lastInput>1800){phase += dt*Math.PI*2/24000;target=(1-Math.cos(phase))/2;root.dataset.motion='looping';}
    else {phase=Math.acos(1-2*shown);root.dataset.motion=paused?'paused':'interactive';}
    shown += (target-shown)*(1-Math.exp(-dt/94));
    opticalShownX += (opticalX-opticalShownX)*(1-Math.exp(-dt/116));
    opticalShownY += (opticalY-opticalShownY)*(1-Math.exp(-dt/116));
    surface.style.setProperty('--core-x',`${(opticalShownX*3).toFixed(2)}px`);
    surface.style.setProperty('--core-y',`${(opticalShownY*2).toFixed(2)}px`);
    if(duration && !video.seeking){const time=(.02+.96*shown)*duration;if(Math.abs(video.currentTime-time)>.025)video.currentTime=Math.min(duration-.04,time);}
    if(document.activeElement!==slider)slider.value=String(Math.round(shown*100));
    root.dataset.progress=shown.toFixed(3);
    if(!paused || Math.abs(target-shown)>.001 || Math.abs(opticalX-opticalShownX)>.001 || Math.abs(opticalY-opticalShownY)>.001 || video.seeking)request();else lastFrame=0;
  }
  function sync() {
    cancelAnimationFrame(raf);raf=0;lastFrame=0;
    controls.hidden=isReduced();root.dataset.motion=isReduced()?'reduced':'interactive';
    if(isReduced()){video.pause();video.removeAttribute('src');video.load();duration=0;root.classList.remove('ready');surface.style.setProperty('--core-x','0px');surface.style.setProperty('--core-y','0px');status.textContent='Still view · reduced motion';}
    else {status.textContent='';load();request();}
  }
  surface.addEventListener('pointerdown',event=>{if(isReduced())return;dragging=true;unlock();point(event);surface.setPointerCapture(event.pointerId);},{passive:true});
  surface.addEventListener('pointerup',()=>{dragging=false;},{passive:true});
  surface.addEventListener('pointercancel',()=>{dragging=false;},{passive:true});
  surface.addEventListener('pointermove',event=>{if(isReduced()||(event.pointerType==='touch'&&!dragging))return;const rect=surface.getBoundingClientRect(),x=smooth(clamp((event.clientX-rect.left)/rect.width)),y=smooth(clamp((event.clientY-rect.top)/rect.height));opticalX=x*2-1;opticalY=y*2-1;input(x);},{passive:true});
  surface.addEventListener('pointerleave',()=>{opticalX=opticalY=0;request();});
  slider.addEventListener('pointerdown',unlock,{passive:true});
  slider.addEventListener('input',()=>{unlock();input(Number(slider.value)/100);});
  button.addEventListener('click',()=>{paused=!paused;target=shown;lastInput=performance.now();button.textContent=paused?'Resume motion':'Pause motion';button.setAttribute('aria-pressed',String(paused));request();});
  window.addEventListener('scroll',()=>{if(!visible||isReduced())return;const r=surface.getBoundingClientRect();input(clamp((innerHeight-r.top)/(innerHeight+r.height)));},{passive:true});
  video.addEventListener('loadedmetadata',()=>{duration=Number.isFinite(video.duration)?video.duration:0;request();});
  video.addEventListener('loadeddata',()=>{root.classList.add('ready');request();});
  video.addEventListener('seeked',()=>{if(video.readyState>=2)root.classList.add('ready');request();});
  video.addEventListener('error',()=>{failed=true;root.classList.remove('ready');controls.hidden=true;status.textContent='Still view · motion is unavailable';cancelAnimationFrame(raf);raf=0;});
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible){lastFrame=0;load();request();}else{cancelAnimationFrame(raf);raf=0;video.pause();root.dataset.motion='offscreen';}},{threshold:.01}).observe(surface);
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(raf);raf=0;video.pause();}else{lastFrame=0;request();}});
  reduced.addEventListener('change',sync);sync();
})();
